export default "__VITE_ASSET__deb4e041__"